@if (advancedSearchOpened$ | async) {
  <div class="advanced-search">
    <div class="advanced-search-header">
      <h4>{{ "advanced-search.title.advanced-search" | translate }}</h4>
      <div class="toolbar">
        <div class="toolbar__left">
          <sui-button
            class="btn-hints"
            variant="secondary"
            [leadingIcon]="['fas', 'question']"
            [iconOnly]="true"
            [ariaLabel]="'search-builder.button.show-hints' | translate"
            [suiTooltip]="'search-builder.button.show-hints' | translate"
            (click)="openHints()"
          ></sui-button>
          <sui-button
            class="btn-copy"
            variant="primary"
            [leadingIcon]="['fas', 'copy']"
            [iconOnly]="true"
            [ariaLabel]="'advanced-search.button.copy-to-clipboard' | translate"
            [suiTooltip]="
              'advanced-search.button.copy-to-clipboard' | translate
            "
            [disabled]="!currentQuery || currentQuery === ''"
            (click)="copyToClipboard()"
          ></sui-button>
          @if (copiedToClipboard) {
            <span>{{ "advanced-search.message.copied!" | translate }}</span>
          }
          <sui-button
            variant="secondary"
            [leadingIcon]="['fas', 'layer-group']"
            [iconOnly]="true"
            [ariaLabel]="'advanced-search.button.save-as-dimension' | translate"
            [suiTooltip]="
              'advanced-search.button.save-as-dimension' | translate
            "
            [disabled]="!currentQuery || currentQuery === ''"
            (click)="saveAsDimension()"
          ></sui-button>
          <sui-button
            variant="secondary"
            [leadingIcon]="['fas', 'link']"
            [iconOnly]="true"
            [ariaLabel]="
              'advanced-search.button.create-&-attach-dimension' | translate
            "
            [suiTooltip]="
              'advanced-search.button.create-&-attach-dimension' | translate
            "
            [disabled]="!currentQuery || currentQuery === ''"
            (click)="attachAndSaveAsDimension()"
          ></sui-button>
        </div>
        <div class="toolbar__center">
          <sui-button
            class="remove-filter"
            variant="danger"
            [leadingIcon]="['fas', 'filter-circle-xmark']"
            [iconOnly]="true"
            [ariaLabel]="
              'advanced-search.button.clear-advanced-search-query' | translate
            "
            [suiTooltip]="
              'advanced-search.button.clear-advanced-search-query' | translate
            "
            (click)="removeFilter()"
          ></sui-button>
          <sui-button
            variant="primary"
            [leadingIcon]="['fas', 'search']"
            [iconOnly]="true"
            [ariaLabel]="
              'advanced-search.button.apply-search-(-Ctrl-+-Enter-)' | translate
            "
            [suiTooltip]="
              'advanced-search.button.apply-search-(-Ctrl-+-Enter-)' | translate
            "
            (click)="applySearch()"
          ></sui-button>
        </div>
        <div class="toolbar__right">
          <sui-button
            class="close-btn"
            size="sm"
            variant="danger"
            [leadingIcon]="['fas', 'xmark']"
            [iconOnly]="true"
            ariaLabel="Close"
            (click)="closeAdvancedSearch()"
          ></sui-button>
        </div>
      </div>
    </div>
    <div class="resizable-box" #resizableBox>
      <app-query-editor
        [ctrlEnterExtension]="ctrlEnterExtension"
        [query]="searchQuery"
        [objectTypeId]="feed.object_type_id"
        [handleQueryInputChanges]="false"
        (queryChange)="handleQueryChange($event)"
        #queryEditor
      ></app-query-editor>
      <div class="resize-handle" (mousedown)="startResize($event)">
        <div class="resize-button">
          <fa-icon [icon]="['fas', 'arrows-up-down']"></fa-icon>
        </div>
      </div>
    </div>
  </div>
}

@if (
  (queryHintsOverlayService.currentlyOpen$ | async)?.componentId === componentId
) {
  <div
    class="hints-wrapper"
    [class.open-sidebar]="sidebarOpened$ | async"
    [class.wide]="sidebarWide$ | async"
  >
    <app-feed-query-hints-popup
      [objectTypeId]="$safeNavigationMigration(feed?.object_type_id)"
      (close)="closeHints()"
      (hintSelected)="addHint($event)"
    ></app-feed-query-hints-popup>
  </div>
}
